	A centralized view of Collaboration Protection resources across Chat, Meetings, Channels, and Drive for clear visibility into available protections.

	<div class="page-inner-content-holder no-scroll flxClmn">
		<trustifi-table-c #resourcesTableEl
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="collaborationResources"
			[headers]="[
				{text: 'Name', sortKey: 'name'},
				{text: 'Type', sortKey: 'resource_type', width: '140px'},
				{text: 'Findings', sortKey: '_findings.maliciousCount'},
				{text: 'Members'},
				{text: 'External Members'},
				{text: 'Last Activity', sortKey: 'last_updated', width: '15%'},
			]"
			[cellsPrototype]="[
				{textKey: 'name'},
				{html: 'typeCell'},
				{html: 'findingsCell'},
				{html: 'membersCell'},
				{html: 'externalMembersCell'},
				{textKey: 'last_updated', textType: 'dateAndTime'},
			]"
			[bulkActions] = "{
				enable: true,
				selectBulkActionCb:	selectResourceMultipleAction,
				initBulkActionsFunction: showResourceMultipleActions,
			}"
			[cellActions] = "{
				enable: true,
				selectItemActionCb:	selectResourceAction,
				initActionsFunction: showResourceActions,
			}"
			[filterData]="filterData"
			(searchFunction)="searchResources($event.searchTerm, $event.activeFilters)"
			[options]="{
				itemsNameSingular: 'resource',
				loadingTableFlag: loadingInProcess,
				exportToCsvFunction: exportToCsv,
				isEllipsis: false,
				refreshFunction: getCollaborationResources,
				defaultSortKey: '-last_updated'
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--status cell-->
				<span *ngIf="cellId === 'typeCell'">
					<span class="resource-type-chip">
						<i class="far" [ngClass]="{
							'fa-hashtag': item.resource_type === 'channel',
							'fa-comments': item.resource_type === 'chat',
							'fa-video': item.resource_type === 'meeting',
							'fa-globe': item.resource_type === 'site',
							'fa-cloud': item.resource_type === 'OneDrive',
							'fa-users': item.resource_type === 'team'
						}"></i>
						{{item.resource_type}}
					</span>
					<span class="resource-type-chip" *ngIf="item.resource_sub_type === 'site'">
						<i class="far fa-globe"></i>
						site
					</span>
					<span class="resource-type-chip" *ngIf="item.resource_sub_type === 'channel'">
						<i class="far fa-hashtag"></i>
						channel
					</span>
				</span>

				<div *ngIf="cellId === 'findingsCell'" class="flex-column gap-1 align-items-start">
					<div class="category-badge category-malicious" *ngIf="item._findings?.maliciousCount">
						<i class="far fa-bug"></i>
						<span>{{item._findings.maliciousCount}} {{item._findings.topMaliciousStatus}}</span>
					</div>
					<div class="category-badge category-dlp" *ngIf="item._findings?.dlpCount">
						<i class="fas fa-shield-alt"></i>
						<span>{{item._findings.dlpCount}} DLP</span>
					</div>
				</div>

				<span *ngIf="cellId === 'membersCell'">
					{{item.members.join(', ')}}
				</span>

				<span *ngIf="cellId === 'externalMembersCell'">
					{{item.external_members?.join(', ')}}
				</span>
			</ng-template>

			<div tableButtons>
			</div>

		</trustifi-table-c>
	</div>

<popup-c *ngIf="currentResourceAssetsPopup"
		 head="{{currentResourceAssetsPopup.name}} — Assets"
		 class="bs-enabled"
		 width="1400px"
		 (closeCb)="currentResourceAssetsPopup = null;"
		 size="large">

	<div class="f-1-0 h100 w100 flxClmn" style="overflow: auto;">
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="currentResourceAssetsPopup.assets"
			[headers]="[
				{text: 'Detected', sortKey: 'created', width: '110px'},
				{text: 'User', sortKey: 'user'},
				{text: 'Type', sortKey: 'asset_type', width: '90px'},
				{text: 'Category', sortKey: 'category', width: '115px'},
				{text: 'Detection Details'},
				{text: 'Access', width: '130px'},
			]"
			[cellsPrototype]="[
				{html: 'createdCell'},
				{textKey: 'user'},
				{html: 'typeCell'},
				{html: 'categoryCell'},
				{html: 'detectionCell'},
				{html: 'accessCell'},
			]"
			[cellActions]="{
				enable: true,
				selectItemActionCb: selectAssetActionInPopup,
				initActionsFunction: showAssetActionsInPopup
			}"
			[options]="{
				itemsNameSingular: 'asset',
				defaultSortKey: '-created',
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">

				<!--Detected date-->
				<span *ngIf="cellId === 'createdCell'"
					  style="white-space: normal; text-overflow: unset; text-align: center; display: block; max-width: min-content;">
					{{item.created | date:'MM/dd/yyyy HH:mm'}}
				</span>

				<!--Type: file/message with icon-->
				<div class="flex-column gap-1" *ngIf="cellId === 'typeCell'">
					<div class="flex-row gap-1 align-items-center">
						<i class="far" style="font-size: 11px; color: #64748b;" [ngClass]="{
							'fa-file-alt': item.asset_type === 'file',
							'fa-comment-alt': item.asset_type === 'message'
						}"></i>
						<span>{{item.asset_type | titlecase}}</span>
					</div>
					<span *ngIf="item.asset_type === 'file' && item.size" style="font-size: 11px; color: #64748b;">{{item.size | FormatBytes}}</span>
				</div>

				<!--Category: colored badge for DLP or Malicious-->
				<div *ngIf="cellId === 'categoryCell'">
					<div class="category-badge category-dlp" *ngIf="item.category === 'DLP'">
						<i class="fas fa-shield-alt"></i>
						<span>DLP</span>
						<span class="sensitivity-score-badge"
							  [ngStyle]="{'background': sensitivityScoreColor(item.sensitivity_info?.score)}">
							{{item.sensitivity_info?.score}}
						</span>
					</div>
					<div class="category-badge category-malicious" *ngIf="item.category === 'Malicious'">
						<i class="far fa-bug"></i>
						<span>{{item.malicious_info?.status}}</span>
					</div>
					<div class="category-badge category-rules" *ngIf="item.category === 'Rule'"
						 [tooltip]="item.info?.rule_name ? 'Rule: ' + item.info?.rule_name : null">
						<i class="far fa-list"></i>
						<span style="text-decoration: underline; text-decoration-style: dotted;">Rules</span>
					</div>
				</div>

				<!--Detection Details: sensitive types or malicious sub-category-->
				<div *ngIf="cellId === 'detectionCell'" class="flex-column gap-1">
					<ng-container *ngIf="item.category === 'DLP'">
						<div class="flex-row gap-1 flex-wrap justify-content-start">
							<span class="detection-tag detection-tag-dlp" *ngFor="let type of item._topSensitiveTypes">
								{{type}}
							</span>
						</div>
						<span class="opacity-50" style="font-size: 11px;" *ngIf="item.sensitivity_info.sensitive_types?.length > 3">
							+{{item.sensitivity_info.sensitive_types.length - 3}} more
						</span>
					</ng-container>
					<ng-container *ngIf="item.category === 'Malicious'">
						<div class="flex-column gap-1">
							<div class="flex-row gap-1 flex-wrap justify-content-start" *ngIf="item._maliciousSubCategory?.length">
								<span class="detection-tag detection-tag-malicious" *ngFor="let msg of item._maliciousSubCategory">
									{{msg}}
								</span>
							</div>
							<span class="opacity-75 ellipsis" style="font-size: 11px;" *ngIf="item.malicious_info?.domain"
								  tooltip="{{item.malicious_info?.url}}" placement="top">
								{{item.malicious_info?.domain}}
							</span>
						</div>
					</ng-container>
					<ng-container *ngIf="item.category === 'Rule'">
						<span *ngIf="item.info?.rule_name">
							Rule: {{item.info.rule_name}}
						</span>
					</ng-container>
				</div>

				<!--Access: members count + permission scope-->
				<div *ngIf="cellId === 'accessCell'" class="flex-column gap-1">
					<div class="flex-row gap-1 align-items-center" *ngIf="item.resource_id?.members?.length"
						 tooltip="{{item.resource_id?.members?.join('
')}}" placement="top">
						<i class="far fa-users" style="font-size: 10px; color: #64748b;"></i>
						<span class="members-hover-link" style="font-size: 12px;">{{item.resource_id?.members?.length}} member{{item.resource_id?.members?.length !== 1 ? 's' : ''}}</span>
						<span class="external-badge" *ngIf="item.resource_id?.external_members?.length"
							  tooltip="{{item.resource_id?.external_members?.join('
')}}" placement="top">
							{{item.resource_id?.external_members?.length}} ext
						</span>
					</div>
					<div class="flex-row gap-1 align-items-center" *ngIf="item.permissions?.link?.scope"
						 (click)="$event.stopPropagation();">
						<i class="far fa-exclamation-triangle text-warning" style="font-size: 10px;"
						   *ngIf="item.permissions?.link?.scope === 'anonymous'"
						   tooltip="This file is publicly accessible">
						</i>
						<span class="permission-scope-chip"
							  [ngClass]="{
								'scope-anonymous': item.permissions?.link?.scope === 'anonymous',
								'scope-external': item.permissions?.link?.scope === 'external',
								'scope-organization': item.permissions?.link?.scope === 'organization',
								'scope-users': item.permissions?.link?.scope === 'users'
							  }">
							{{item.permissions?.link?.scope | titlecase}}
						</span>
						<i style="font-weight: 400; font-size: 11px;" class="far fa-question-circle opacity-50"
						   [tooltip]="linkScopeTooltips[item.permissions?.link?.scope]" placement="right"></i>
					</div>
				</div>

			</ng-template>
		</trustifi-table-c>
	</div>
</popup-c>

<collaboration-asset-info
	*ngIf="currentAssetInfoObj"
	[asset]="currentAssetInfoObj"
	(closeCb)="currentAssetInfoObj = null;">
</collaboration-asset-info>

